@import '../../style/index';
@import '../../style/layout/index';

:host {
  .footer {
    position: absolute;
    left: 0;
    right: 0;
    background-color: var(--colors-dark-base);
    border-top: 2px solid var(--colors-primary-base);
    padding: var(--spacings-m) 0;
    margin-top: var(--spacings-xxl);

    /* stylelint-disable declaration-no-important */
    &__container {
      box-sizing: border-box;
      display: block;
      max-width: calc(100% - var(--spacings-s) * 2);
      margin: 0 auto;

      @include xlarge-up() {
        max-width: $max-width-container-xlarge !important;
      }

      @include xxlarge-up() {
        max-width: $max-width-container-xxlarge !important;
      }

      @include large-up {
        padding-top: var(--spacings-xl);
        padding-bottom: var(--spacings-l);
      }
    }

    p {
      @include copy-secondary();

      color: var(--colors-basic-white);
      margin-top: 0;
      margin-bottom: 0;
    }

    &__main {
      padding-bottom: var(--spacings-xl);
    }

    &__company-info {
      @include large-up {
        max-width: 80%;
      }

      > p {
        margin-top: var(--spacings-m);
      }
    }

    &__logo {
      display: flex;
    }

    &__grid {
      display: flex;

      rcm-column {
        justify-content: flex-end;
        flex-basis: auto;

        > ul {
          display: flex;
          margin: 0;
          list-style-type: none;
          padding: 0;
          flex-wrap: wrap;

          > li {
            button {
              @include copy-secondary();

              margin-top: 0;
              margin-bottom: 0;
              color: var(--colors-basic-white);
              padding-right: var(--spacings-m);
              vertical-align: top;
              background-color: transparent;
              text-decoration: underline;
              border: none;
              padding-left: 0;
              cursor: pointer;

              &:hover {
                color: var(--colors-grey-base);
              }
            }
          }
        }
      }
    }

    &__sitemap-links {
      display: none !important;

      @include xlarge-up() {
        display: flex !important;
      }
    }

    .sitemap__column {
      display: flex;
      flex-direction: column;
      justify-content: start;
      gap: 1rem;

      rcm-text-link {
        --colors-dark-base: var(--colors-basic-white);

        &:hover {
          --colors-dark-medium: var(--colors-grey-base);
        }

        @include copy-secondary();

        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &__bottom-links {
      li {
        padding-right: var(--spacings-m);
      }

      p {
        @include copy-secondary();

        margin-top: 0;
        margin-bottom: 0;
        color: var(--colors-basic-white);
        text-align: end;
      }

      rcm-column {
        margin: var(--spacings-s) 0;
      }

      span {
        @include copy-secondary();

        color: var(--colors-basic-white);
        vertical-align: top;
        text-decoration: underline;

        &:hover {
          color: var(--colors-grey-base);
        }
      }
    }

    &__bottom-social {
      display: flex;
      flex-direction: row-reverse;
      margin-bottom: 2rem;

      rcm-column {
        text-align: right;
        margin: var(--spacings-s) 0 0;
      }

      @include xlarge-up() {
        margin-bottom: 0;

        rcm-column {
          margin: var(--spacings-s) 0;
        }

        rcm-column:nth-child(2) {
          text-align: left;
        }
      }
    }
  }
}
